var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSidebarCollapsed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8752 14.1918H13.7496V15.2465H8.8752V14.1918ZM8.8752 2.72031H16.418V3.775H8.8752V2.72031ZM7.53574 2.31953V6.9584C7.53574 7.33105 7.2334 7.6334 6.86074 7.6334H2.22188C1.84922 7.6334 1.54688 7.33105 1.54688 6.9584V2.31953C1.54688 1.94687 1.84922 1.64453 2.22188 1.64453H6.86074C7.23164 1.64453 7.53574 1.94687 7.53574 2.31953ZM8.8752 5.50293H13.7496V6.55762H8.8752V5.50293ZM7.53574 11.0084V15.6473C7.53574 16.0199 7.2334 16.3223 6.86074 16.3223H2.22188C1.84922 16.3223 1.54688 16.0199 1.54688 15.6473V11.0084C1.54688 10.6357 1.84922 10.3334 2.22188 10.3334H6.86074C7.23164 10.3334 7.53574 10.6375 7.53574 11.0084ZM8.8752 11.4092H16.418V12.4639H8.8752V11.4092Z",
    fill: "url(#paint0_linear_1768_422)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1768_422",
    x1: 1.54687,
    y1: 1.64453,
    x2: 1.71944,
    y2: 16.4931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345D8B"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSidebarCollapsed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/SidebarCollapsed.cbdfd00e.svg";
export { ForwardRef as ReactComponent };